import React from "react";
import { MenuItem } from "@material-ui/core";
import { Select } from "admin/_common/components/Select";
import { TUnitMdl } from "admin/units/_models/UnitMdl";
import { UnitTypeDialog } from "unitTypes/UnitTypeDialog";
import { usePropertyStore } from "properties/propertyPage/PropertyContext";
import { unitTypesStore } from "unitTypes/_store/unitTypesStore";
import { TFilterType } from "admin/_common/resources/ResourceFilterMdl";
import { observer } from "mobx-react-lite";

export const BuildableUnitTypesSelector = observer(({ unit }: { unit: TUnitMdl }) => {
    const [selectedUnitType, setSelectedUnitType] = React.useState<string>("none");
    const { property } = usePropertyStore();
    const listStore = unitTypesStore.getListStore(property._id, Number.MAX_SAFE_INTEGER, [
        { id: "property", type: TFilterType.ID, value: property._id },
    ]);

    if (!unit.unitTypeIds?.length) return null;

    const unitTypes = listStore.items.filter((item) => unit.unitTypeIds!.includes(item!._id));
    const unitType = unitTypes.find((item) => item!._id === selectedUnitType);

    if (!unitTypes?.length) return null;

    return (
        <>
            <UnitTypeDialog
                unitType={unitType}
                open={selectedUnitType !== "none"}
                onClose={() => setSelectedUnitType("none")}
            />
            <Select
                value={selectedUnitType}
                defaultValue={"none"}
                className={"w-full"}
                onChange={(e) => {
                    setSelectedUnitType(e.target.value as string);
                }}
                variant={"outlined"}
            >
                <MenuItem value={"none"} key={"none"}>
                    Select a unit type
                </MenuItem>
                {unitTypes.map((uniType) => (
                    <MenuItem value={uniType!._id} key={uniType!._id}>
                        {uniType?.localized.title}
                    </MenuItem>
                ))}
            </Select>
        </>
    );
});
